<div
  class="flex flex-row justify-around items-center w-full h-full bg-gradient-to-br from-blue from-0% via-[#042E3F] via-15% to-green to-90% min-w-[912px]">
  <div class="w-[800px] h-[640px] rounded-md flex flex-row items-center"
       [class]="isRegister ? 'justify-start' : !isRegister && !isVerify && !isPasswordReset ? 'justify-end' : 'justify-center'">

    <ng-container *ngIf="isDeletedAccount">
      <div class="flex flex-row justify-center items-start w-[800px] h-[640px] bg-blue rounded-md absolute">
        <div class="flex flex-col justify-between items-start w-[400px] px-8 py-16 h-full">
          <div class="flex flex-col justify-center items-start gap-4 mb-4">
            <span class="text-white text-xl">Schade, dass Sie uns verlassen</span>
            <span class="text-white text-sm">Ihr Konto wurde deaktiviert und die Löschung beauftragt.</span>
          </div>

          <div class="flex flex-col justify-start items-start w-full gap-1">
            <span class="text-green text-sm font-medium">Hinweis</span>
            <span class="text-white text-sm">Die endgültige Löschung Ihrer Nutzerdaten erfolgt nach Ablauf einer
              Frist von 30 Tagen. In diesem Zeitraum können Sie die Löschung selbst widerrufen: Melden Sie sich
              einfach wie gewohnt an, wir fragen Sie dann, ob Ihr Konto reaktiviert werden soll. Ist die Frist
              abgelaufen, hilft Ihnen unser <a class="text-green underline"
                                        href="mailto:support@thinkbic.de">Support-Team</a> weiter.</span>
          </div>

          <div class="flex flex-col w-full">
            <bic-button (onClick)="backToLogin()"
                        [fullWidth]="true"
                        class="h-[44px]">
              Zurück zum Login
            </bic-button>
          </div>
        </div>

        <div
          class="flex flex-col justify-between items-center z-40 w-[400px] h-full bg-white rounded-r-md relative gap-1">
          <div class="flex w-full pt-24 flex-col justify-center items-center gap-1">
            <img class="w-[200px] h-[160px]" height="16" ngSrc="assets/logo_gradient.svg" width="16">
            <a class="text-[40px] font-bold font-brand text-blue -mt-6">planBIC</a>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- Self-Service-Reaktivierung: erscheint nach erfolgreicher Anmeldung an einem zur Löschung
         vorgemerkten Konto. Bis hier ist noch kein Access-Token im Spiel - die App bleibt zu,
         bis die Löschung zurückgenommen ist. -->
    <ng-container *ngIf="isReactivate">
      <div class="flex flex-row justify-center items-start w-[800px] h-[640px] bg-blue rounded-md absolute">
        <div class="flex flex-col justify-between items-start w-[400px] px-8 py-16 h-full">
          <div class="flex flex-col justify-center items-start gap-4 mb-4">
            <span class="text-white text-xl">Willkommen zurück</span>
            <span class="text-white text-sm">Dieses Konto ist zur Löschung vorgemerkt<span
              *ngIf="deletionDateText"> und wird am {{ deletionDateText }} endgültig entfernt</span>.
              Möchten Sie die Löschung zurücknehmen?</span>
          </div>

          <div class="flex flex-col justify-start items-start w-full gap-1">
            <span class="text-green text-sm font-medium">Hinweis</span>
            <span class="text-white text-sm">Bis zur endgültigen Löschung sind Ihre Projekte und
              Daten unverändert vorhanden. Behalten Sie die Löschung bei, können Sie sich innerhalb
              der Frist jederzeit erneut anmelden und sie hier zurücknehmen.</span>
          </div>

          <div class="flex flex-col w-full gap-3">
            <bic-button (onClick)="reactivate()"
                        [fullWidth]="true"
                        [loading]="reactivateLoading"
                        class="h-[44px]">
              Konto reaktivieren
            </bic-button>
            <bic-button (onClick)="keepDeletion()"
                        buttonType="white"
                        [fullWidth]="true"
                        class="h-[44px]">
              Löschung beibehalten
            </bic-button>
          </div>
        </div>

        <div
          class="flex flex-col justify-between items-center z-40 w-[400px] h-full bg-white rounded-r-md relative gap-1">
          <div class="flex w-full pt-24 flex-col justify-center items-center gap-1">
            <img class="w-[200px] h-[160px]" height="16" ngSrc="assets/logo_gradient.svg" width="16">
            <a class="text-[40px] font-bold font-brand text-blue -mt-6">planBIC</a>
          </div>
        </div>
      </div>
    </ng-container>

<!--    <ng-container *ngIf="!isRegister && !isVerify && !isPasswordReset && !isDeletedAccount && !isMfa">-->

    <ng-container *ngIf="isMfa">
      <div class="flex flex-col justify-center items-start w-[800px] h-[640px] bg-blue rounded-md absolute">
        <div class="flex flex-col justify-start w-[400px] px-8 pt-32 pb-16 h-full gap-4">
          <div class="flex flex-col justify-center items-start gap-4">
            <div class="text-white text-xl py-2">Authentifizierung</div>
            <div class="text-white text-sm py-2">Bitte geben Sie den 6-stelligen Code ein</div>
          </div>

          <form (ngSubmit)="verifyMfa()" [formGroup]="mfaForm"
                class="flex flex-col w-full h-full justify-start items-start gap-6">

            <div class="flex flex-col justify-between h-full w-full">
              <div class="flex flex-col w-full">
                <!--              <label for="code" class="block text-sm mb-1 font-medium text-white">2FA Code</label>-->
                <div class="flex flex-row justify-between w-full pb-6" id="code">
                  <input #otpInput (input)="moveToNext($event, 0)" (keydown)="moveToNext($event, 0)"
                         (paste)="moveToNext($event, 0)"
                         [class]="mfaError ? 'text-red ring-red border-red' : 'text-white focus:ring-white focus:border-white border-gray-600'"
                         class="text-center text-sm rounded-lg bg-gray-700 placeholder-gray-400 block w-10 p-2.5"
                         formControlName="code1" maxlength="1"
                         type="number">
                  <input #otpInput (input)="moveToNext($event, 1)" (keydown)="moveToNext($event, 1)"
                         (paste)="moveToNext($event, 1)"
                         [class]="mfaError ? 'text-red ring-red border-red' : 'text-white focus:ring-white focus:border-white border-gray-600'"
                         class="text-center text-sm rounded-lg bg-gray-700 placeholder-gray-400 block w-10 p-2.5"
                         formControlName="code2" maxlength="1"
                         type="number">
                  <input #otpInput (input)="moveToNext($event, 2)" (keydown)="moveToNext($event, 2)"
                         (paste)="moveToNext($event, 2)"
                         [class]="mfaError ? 'text-red ring-red border-red' : 'text-white focus:ring-white focus:border-white border-gray-600'"
                         class="text-center text-sm rounded-lg bg-gray-700 placeholder-gray-400 block w-10 p-2.5"
                         formControlName="code3" maxlength="1"
                         type="number">
                  <input #otpInput (input)="moveToNext($event, 3)" (keydown)="moveToNext($event, 3)"
                         (paste)="moveToNext($event, 3)"
                         [class]="mfaError ? 'text-red ring-red border-red' : 'text-white focus:ring-white focus:border-white border-gray-600'"
                         class="text-center text-sm rounded-lg bg-gray-700 placeholder-gray-400 block w-10 p-2.5"
                         formControlName="code4" maxlength="1"
                         type="number">
                  <input #otpInput (input)="moveToNext($event, 4)" (keydown)="moveToNext($event, 4)"
                         (paste)="moveToNext($event, 4)"
                         [class]="mfaError ? 'text-red ring-red border-red' : 'text-white focus:ring-white focus:border-white border-gray-600'"
                         class="text-center text-sm rounded-lg bg-gray-700 placeholder-gray-400 block w-10 p-2.5"
                         formControlName="code5" maxlength="1"
                         type="number">
                  <input #otpInput (input)="moveToNext($event, 5)" (keydown)="moveToNext($event, 5)"
                         (paste)="moveToNext($event, 5)"
                         [class]="mfaError ? 'text-red ring-red border-red' : 'text-white focus:ring-white focus:border-white border-gray-600'"
                         class="text-center text-sm rounded-lg bg-gray-700 placeholder-gray-400 block w-10 p-2.5"
                         formControlName="code6" maxlength="1"
                         type="number">
                </div>
                <ng-container *ngIf="loginForm.get('code1')?.touched && loginForm.get('code1')?.invalid">
                  <span *ngIf="loginForm.get('code1')?.errors?.required" class="text-xs text-red pt-1">Sie müssen den 2FA Code eingeben.</span>
                  <span *ngIf="loginForm.get('code1')?.errors?.pattern" class="text-xs text-red pt-1">Der Code muss 6 Ziffern lang sein.</span>
                </ng-container>
                <ng-container *ngIf="mfaError">
                  <span class="text-xs text-red pt-1">Der eingegebene Code ist nicht korrekt.</span>
                </ng-container>
                <span (click)="resendMail()" *ngIf="response!.isMailMfa"
                      class="text-sm text-green items-start hover:cursor-pointer">Code nicht erhalten?</span>
                <span (click)="resendMail()" *ngIf="!response!.isMailMfa"
                      class="text-sm text-green items-start hover:cursor-pointer">Keinen Zugriff auf die App?</span>
              </div>

              <div class="flex flex-col w-full">
                <bic-button [fullWidth]="true"
                            [loading]="mfaLoading"
                            class="h-[44px] mt-6">
                  Anmelden
                </bic-button>
              </div>
            </div>
          </form>
        </div>


      </div>

      <div class="flex flex-col justify-between items-center z-40 w-[400px] h-full bg-white rounded-r-md relative gap-1"
        [class]="window.history.state['fromRegister'] ? 'animate-login' : '' ">
        <div class="flex w-full pt-24 flex-col justify-center items-center gap-1">
          <img class="w-[200px] h-[160px]" height="16" ngSrc="assets/logo_gradient.svg" width="16">
          <a class="text-[40px] font-bold font-brand text-blue -mt-6">planBIC</a>
        </div>


        <div class="flex flex-col justify-end items-center pb-16">
          <a [routerLink]="['/login']" [state]="{'fromLogin': true, 'fromRegister': false}"
             class="text-sm font-medium text-green">Zurück zum Login</a>
        </div>
      </div>

    </ng-container>


<!--    <ng-container *ngIf="isMfa">-->
<ng-container *ngIf="!isRegister && !isVerify && !isPasswordReset && !isDeletedAccount && !isMfa && !isReactivate">
  <div class="flex flex-col justify-center items-start w-[800px] h-[640px] bg-blue rounded-md absolute">
      <div class="flex flex-col justify-start w-[400px] px-8 pt-32 pb-16 h-full">
        <div class="flex flex-col justify-center items-start gap-4 mb-4">
          <div class="text-white text-xl py-2">Willkommen!</div>
          <div class="text-white text-sm py-2">Bitte geben Sie Ihre Anmeldedaten ein.</div>
        </div>

        <form (ngSubmit)="login()" [formGroup]="loginForm"
              class="flex flex-col w-full justify-between items-start h-full">

          <div class="flex flex-col w-full h-full justify-start">
            <div class="flex flex-col w-full" [class]=" (loginForm.get('mail')?.touched && loginForm.get('mail')?.invalid)  || notRegisteredError? 'pb-0.5' : 'pb-6'">
              <bic-input [dark]="true" [formGroup]="loginForm" formControlName="mail" (blur)="loginForm.get('mail')?.markAsTouched()" (focus)="loginForm.get('mail')?.markAsUntouched()"
                         [errorCondition]="loginForm.get('mail')?.touched && loginForm.get('mail')?.invalid" [formControlName]="'mail'" [label]="'E-Mail'"
                         [placeholder]="'E-Mail Adresse'"></bic-input>
              <ng-container *ngIf="loginForm.get('mail')?.touched && loginForm.get('mail')?.invalid">
                <span class="text-xs text-red pt-1"
                      *ngIf="loginForm.get('mail')?.errors?.required">Sie müssen Ihre E-Mail eingeben.</span>
                <span class="text-xs text-red pt-1"
                      *ngIf="loginForm.get('mail')?.errors?.email">Bitte geben Sie eine valide E-Mail-Adresse an!</span>
              </ng-container>
              <!--ng-container *ngIf="notRegisteredError">
              <span
                *ngIf="loginForm.get('mail')?.value !== '' && !(loginForm.get('mail')?.touched && loginForm.get('mail')?.invalid)"
                class="text-xs text-red pt-1 w-full">Zu dieser E-Mail Adresse wurde
              noch kein Account erstellt!</span>
              </ng-container-->

            </div>

            <div class="flex flex-col w-full" [class]="loginForm.get('password')?.touched && loginForm.get('password')?.invalid ? 'pb-0.5' : 'pb-6'">
              <bic-input [dark]="true" [isPassword]="true" [formGroup]="loginForm" formControlName="password" (blur)="loginForm.get('password')?.markAsTouched()" (focus)="loginForm.get('password')?.markAsUntouched()"
                         [(showPassword)]="showPassword" [errorCondition]="loginForm.get('password')?.touched && loginForm.get('password')?.invalid" [formControlName]="'password'"
                         [label]="'Passwort'"
                         [placeholder]="'Passwort'"></bic-input>
              <ng-container *ngIf="loginForm.get('password')?.touched && loginForm.get('password')?.invalid">
                <span *ngIf="loginForm.get('password')?.errors?.required" class="text-xs text-red pt-1">Sie müssen Ihr Passwort eingeben.</span>
              </ng-container>

              <span *ngIf="verificationError && accountStateMessage"
                    class="text-xs text-red pt-1">{{ accountStateMessage }}</span>

            </div>

            <!--            </mat-form-field>-->

            <!--span *ngIf="loginError" class="text-white text-xs text-center w-full">Passwort oder E-Mail inkorrekt!</span-->
            <!--span *ngIf="verificationError" class="text-white text-xs text-center w-full">Ihr Account wurde noch nicht
              verifiziert!</span-->
            <div class="flex flex-row">
                <span [routerLink]="['/resetPassword']" class="text-sm text-green items-start hover:cursor-pointer">Passwort
                vergessen?</span>
            </div>
          </div>


          <div class="flex flex-col w-full">
            <bic-button [fullWidth]="true"
                        [loading]="loginLoading"
                        class="h-[44px] mt-6">
              Anmelden
            </bic-button>
          </div>


        </form>
      </div>


    </div>

    <div
      class="flex flex-col justify-between items-center z-40 w-[400px] h-full bg-white rounded-r-md relative gap-1"
      [class]="window.history.state['fromRegister'] ? 'animate-login' : '' ">
      <div class="flex w-full pt-24 flex-col justify-center items-center gap-1">
        <img class="w-[200px] h-[160px]" height="16" ngSrc="assets/logo_gradient.svg" width="16">
        <a class="text-[40px] font-bold font-brand text-blue -mt-6">planBIC</a>
      </div>
      <div class="flex flex-col justify-end items-center pb-16">
        <a class="text-sm text-blue">Noch nicht registriert?</a>
        <a [routerLink]="['/register']" [state]="{'fromLogin': true, 'fromRegister': false}"
           class="text-sm font-medium text-green">Konto erstellen</a>
      </div>
    </div>
  </ng-container>

    <ng-container *ngIf="isRegister">
<!--    <ng-container *ngIf="isVerify && !authService.isLoggedIn()">-->

      <div class="flex flex-col justify-center items-end w-[800px] h-[640px] bg-blue rounded-md absolute">
        <div class="flex flex-col w-[400px] justify-between px-8 py-16 h-full">
          <div class="flex flex-col h-full">
            <div class="flex flex-col justify-start items-start">
              <div class="text-white text-xl pt-10 pb-6">Jetzt Registrieren!</div>
            </div>
            <div class="flex flex-col w-full">
              <form [formGroup]="registerForm" class="flex flex-col w-full justify-start items-center">

                <div class="flex flex-col w-full" [class]="registerForm.get('firstName')?.touched && registerForm.get('firstName')?.invalid ? 'pb-0.5' : 'pb-6'">
                  <bic-input [dark]="true" [formGroup]="registerForm" formControlName="firstName" (blur)="registerForm.get('firstName')?.markAsTouched()" (focus)="registerForm.get('firstName')?.markAsUntouched()"
                             [label]="'Vorname'" [formControlName]="'firstName'" [type]="'text'" [placeholder]="'Vorname'" [errorCondition]="registerForm.get('firstName')?.touched && registerForm.get('firstName')?.invalid"></bic-input>
                  <ng-container *ngIf="registerForm.get('firstName')?.touched">
                  <span *ngIf="registerForm.get('firstName')?.errors?.required; else invalidNameError"
                        class="text-xs text-red pt-1">
                    Sie müssen Ihren Vornamen angeben!
                  </span>
                    <ng-template #invalidNameError>
                    <span *ngIf="registerForm.get('firstName')?.errors?.invalidName" class="text-xs text-red pt-1">
                      Der Vorname muss mindestens 2 Zeichen lang sein.
                    </span>
                    </ng-template>
                  </ng-container>

                </div>

                <div class="flex flex-col w-full" [class]="registerForm.get('lastName')?.touched && registerForm.get('lastName')?.invalid ? 'pb-0.5' : 'pb-6'">
                  <bic-input [dark]="true" [formGroup]="registerForm" formControlName="lastName" (blur)="registerForm.get('lastName')?.markAsTouched()" (focus)="registerForm.get('lastName')?.markAsUntouched()"
                             [label]="'Nachname'" [formControlName]="'lastName'" [type]="'text'" [placeholder]="'Nachname'" [errorCondition]="registerForm.get('lastName')?.touched && registerForm.get('lastName')?.invalid"></bic-input>
                  <ng-container *ngIf="registerForm.get('lastName')?.touched">
                 <span *ngIf="registerForm.get('lastName')?.errors?.required; else invalidNameError"
                       class="text-xs text-red pt-1">
                    Sie müssen Ihren Nachnamen angeben!
                  </span>
                    <ng-template #invalidNameError>
                    <span *ngIf="registerForm.get('lastName')?.errors?.invalidName" class="text-xs text-red pt-1">
                      Der Nachname muss mindestens 2 Zeichen lang sein.
                    </span>
                    </ng-template>
                  </ng-container>
                </div>

                <div class="flex flex-col w-full" [class]="registerForm.get('mail')?.touched && registerForm.get('mail')?.invalid ? 'pb-0.5' : 'pb-6'">
                  <bic-input [dark]="true" [formGroup]="registerForm" formControlName="mail" (blur)="registerForm.get('mail')?.markAsTouched()" (focus)="registerForm.get('mail')?.markAsUntouched()"
                             [label]="'E-Mail'" [formControlName]="'mail'" [type]="'email'" [placeholder]="'E-Mail Adresse'" [errorCondition]="registerForm.get('mail')?.touched && registerForm.get('mail')?.invalid"></bic-input>

                  <!--                  <label for="mail_registration" class="block mb-1 text-sm font-medium" [class]="registerForm.get('mail')?.touched && registerForm.get('mail')?.invalid ? 'text-red' : 'text-white' ">E-Mail</label>-->
                  <!--                  <input (blur)="registerForm.get('mail')?.markAsTouched()" (focus)="registerForm.get('mail')?.markAsUntouched()" formControlName="mail" type="email" id="mail_registration" [class]="registerForm.get('mail')?.touched && registerForm.get('mail')?.invalid ? 'text-red ring-red border-red' : 'text-white focus:ring-white focus:border-white border-gray-600'"  class="text-sm rounded-lg bg-gray-700  placeholder-gray-400  block w-full p-2.5" placeholder="E-Mail Adresse">-->
                  <ng-container *ngIf="registerForm.get('mail')?.touched && registerForm.get('mail')?.invalid">
                  <span
                    *ngIf="registerForm.get('mail')?.errors?.required" class="text-xs text-red pt-1">Sie müssen Ihre E-Mail eingeben.</span>
                    <span
                      *ngIf="registerForm.get('mail')?.errors?.email" class="text-xs text-red pt-1">Bitte geben Sie eine valide E-Mail-Adresse an!</span>
                  </ng-container>
                </div>
              </form>


              <div class="flex flex-col h-full w-full gap-2">
                <div class="flex flex-row justify-start items-center w-full gap-4 text-sm font-medium">
                  <input
                    (change)="registerForm.controls.termsAndConditions.setValue(!registerForm.controls.termsAndConditions.value)"
                    [checked]="registerForm.controls.termsAndConditions.value == true"
                    class="w-4 h-4 bg-gray-700 border-gray-600 rounded focus:ring-white focus:border-red ring-none focus:ring-0 checked:bg-gray-700"
                    id="default-checkbox" type="checkbox"
                    value="">
                  <div >
                    <a class="text-white">Ich akzeptiere die </a>
                    <a href="https://thinkbic.de/agb/" target="_blank" class="underline text-white">AGB</a>
                    <a class="text-white"> und </a>
                    <a class="underline text-white" href="https://thinkbic.de/datenschutzerklaerung/" target="_blank">Datenschutz&shy;bestimmungen.</a>
                  </div>
                </div>
                <!--                <span *ngIf="alreadyRegisteredError" class="text-xs text-red">Mit dieser E-Mail Adresse wurde bereits ein Account erstellt!</span>-->
                <span *ngIf="alreadyRegisteredError" class="text-xs text-red">{{ accountStateMessage }}</span>
              </div>
            </div>
          </div>

          <div class="flex flex-col w-full">
            <bic-button (onClick)="register()"
                        [fullWidth]="true"
                        [loading]="registerLoading"
                        class="h-[44px]">
              Registrieren
            </bic-button>
          </div>




        </div>
      </div>

      <div class="flex flex-col justify-between items-center z-40 w-[400px] h-full bg-white rounded-l-md relative gap-1"
        [class]="window.history.state['fromLogin'] ? 'animate-register' : '' ">
        <div class="flex w-full pt-24 flex-col justify-center items-center gap-1">
          <img class="w-[200px] h-[160px]" height="16" ngSrc="assets/logo_gradient.svg" width="16">
          <a class="text-[40px] font-bold font-brand text-blue -mt-6">planBIC</a>
        </div>

        <div class="flex flex-col justify-center items-center pb-16">
          <a class="text-sm text-blue">Bereits registriert?</a>
          <a [routerLink]="['/login']" [state]="{'fromRegister': true, 'fromLogin': false}"
             class="text-sm font-medium text-green">Anmelden</a>
        </div>
      </div>

    </ng-container>

<!--        <ng-container *ngIf="isRegister">-->
    <ng-container *ngIf="isVerify && !authService.isLoggedIn()">

      <div class="flex flex-row justify-center items-end w-[800px] h-[640px] bg-blue rounded-md absolute">
            <div class="flex flex-col justify-between items-center w-[400px] h-full bg-white rounded-l-md animate-login relative">
              <div class="flex w-full pt-24 flex-col justify-center items-center gap-1">
                <img class="w-[200px] h-[160px]" height="16" ngSrc="assets/logo_gradient.svg" width="16">
                <a class="text-[40px] font-bold font-brand text-blue -mt-6">planBIC</a>
              </div>
            </div>

        <div class="flex flex-col justify-start items-center w-[400px] h-full bg-blue rounded-r-md px-8 py-16 ">

              <form (ngSubmit)="setPassword()" [formGroup]="passwordForm"
                    class="flex flex-col w-full justify-between items-start gap-4 h-full">
                <div class="flex flex-col w-full items-start">
                  <span class="text-white text-xl py-2">Passwort</span>
                  <span class="text-white text-base pb-2">Wählen Sie ein Passwort für Ihr Konto</span>

                </div>

                <div class="flex flex-col w-full h-full justify-between">
                  <div class="flex flex-col w-full items-start">

                    <div class="flex flex-col w-full" [class]="passwordForm.get('password')?.touched && passwordForm.get('password')?.invalid ? 'pb-0.5' : 'pb-6'">
                      <bic-input [dark]="true" [isPassword]="true" [formGroup]="passwordForm" formControlName="password" (blur)="passwordForm.get('password')?.markAsTouched()" (focus)="passwordForm.get('password')?.markAsUntouched()"
                                 [(showPassword)]="showPassword" [errorCondition]="passwordForm.get('password')?.touched && passwordForm.get('password')?.invalid" [formControlName]="'password'"
                                 [label]="'Passwort'"
                                 [placeholder]="'Passwort'"></bic-input>
                      <ng-container *ngIf="passwordForm.get('password')?.touched && passwordForm.get('password')?.invalid">
                        <span *ngIf="passwordForm.get('password')?.errors?.required" class="text-xs text-red pt-1">Sie müssen Ihr Passwort eingeben.</span>
                        <ng-container *ngIf="!passwordForm.get('password')?.errors?.required">
                          <span *ngIf="!passwordForm.get('password')?.valid" class="text-xs text-red pt-1">Das Passwort entspricht nicht den Sicherheitsvorgaben.</span>
                        </ng-container>

                      </ng-container>

                    </div>

                    <div class="flex flex-col w-full" [class]="passwordForm.get('passwordRepeat')?.touched && passwordForm.get('passwordRepeat')?.invalid ? 'pb-0.5' : 'pb-6'">
                      <bic-input [dark]="true" [isPassword]="true" [formGroup]="passwordForm" formControlName="password" (blur)="passwordForm.get('passwordRepeat')?.markAsTouched()" (focus)="passwordForm.get('passwordRepeat')?.markAsUntouched()"
                                 [(showPassword)]="showPasswordRepeat" [label]="'Passwort wiederholen'" [formControlName]="'passwordRepeat'" [type]="'password'" [placeholder]="'Passwort'" [errorCondition]="passwordForm.get('passwordRepeat')?.touched && passwordForm.get('passwordRepeat')?.invalid"></bic-input>
                      <ng-container *ngIf="passwordForm.get('passwordRepeat')?.touched && passwordForm.get('passwordRepeat')?.invalid">
                        <span *ngIf="passwordForm.get('passwordRepeat')?.errors?.required"
                              class="text-xs text-red pt-1">Sie müssen Ihr Passwort wiederholen.</span>
                        <ng-container *ngIf="passwordForm.get('passwordRepeat')?.errors?.matchValue != null">
                          <span *ngIf="!passwordForm.get('passwordRepeat')?.errors?.matchValue"
                                class="text-xs text-red pt-1">Die Passwörter stimmen nicht überein.</span>
                        </ng-container>
                      </ng-container>

                    </div>

                    <div class="flex flex-col justify-start items-start w-[90%] pb-4">
                      <span class="text-white text-sm font-medium pb-1">Vorgaben Passwortsicherheit</span>
                      <div class="flex flex-row items-center pl-4">
                        <ul class="text-white text-xs list-disc ">
                          <li
                            [class]=" testLength($safeNavigationMigration(passwordForm.get('password')?.value)) ? 'text-green' : 'text-white'">
                            Enthält mindestens 8 Zeichen
                          </li>
                          <li
                            [class]=" testUpperCase($safeNavigationMigration(passwordForm.get('password')?.value)) && testLowerCase($safeNavigationMigration(passwordForm.get('password')?.value)) ? 'text-green' : 'text-white'">
                            Ein Groß- und Kleinbuchstabe
                          </li>
                          <li
                            [class]=" testNumeric($safeNavigationMigration(passwordForm.get('password')?.value)) ? 'text-green' : 'text-white'">
                            Eine Zahl
                          </li>
                          <li
                            [class]=" testSpecialCharacter($safeNavigationMigration(passwordForm.get('password')?.value)) ? 'text-green' : 'text-white'">
                            Ein Sonderzeichen (!\?&%=.\-:*#&#64;$)
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <button
                    class="w-full h-[44px] mt-6 bg-green text-white rounded-lg"
                    type="submit">Passwort bestätigen
                  </button>

                </div>

              </form>
            </div>


          </div>



    </ng-container>

    <ng-container *ngIf="isPasswordReset">

      <div class="flex flex-row justify-center items-start w-[800px] h-[640px] bg-blue rounded-md absolute">
        <div class="flex flex-col justify-start w-[400px] px-8 pt-32 pb-16 h-full">

          <form (ngSubmit)="resetPassword()" [formGroup]="resetPasswordForm"
                class="flex flex-col w-full justify-between items-start h-full">
            <div class="flex flex-col w-full h-full justify-start">
              <div class="flex flex-col justify-center items-start gap-4 mb-4">
                <h1 *ngIf="!isNewVerification" class="text-white text-xl">Passwort zurücksetzen</h1>
                <h1 *ngIf="isNewVerification" class="text-white text-xl">Bestätigungsemail erneuern</h1>
                <span class="text-white text-sm py-2">Bitte geben Sie die E-Mail für Ihr Konto ein.</span>
              </div>

              <div class="flex flex-col w-full">
                <div class="flex flex-col w-full" [class]="resetPasswordForm.get('mail')?.touched && resetPasswordForm.get('mail')?.invalid ? 'pb-0.5' : 'pb-6'">
                  <bic-input [dark]="true" [formGroup]="resetPasswordForm" formControlName="mail" (blur)="resetPasswordForm.get('mail')?.markAsTouched()" (focus)="resetPasswordForm.get('mail')?.markAsUntouched()"
                             [label]="'E-Mail'" [formControlName]="'mail'" [type]="'email'" [placeholder]="'E-Mail Adresse'" [errorCondition]="resetPasswordForm.get('mail')?.touched && resetPasswordForm.get('mail')?.invalid"></bic-input>
                  <ng-container *ngIf="resetPasswordForm.get('mail')?.touched && resetPasswordForm.get('mail')?.invalid">
                  <span
                    *ngIf="resetPasswordForm.get('mail')?.errors?.required" class="text-xs text-red pt-1">Sie müssen Ihre E-Mail eingeben.</span>
                    <span
                      *ngIf="resetPasswordForm.get('mail')?.errors?.email" class="text-xs text-red pt-1">Bitte geben Sie eine valide E-Mail-Adresse an!</span>


                  </ng-container>
                  <span
                    *ngIf="notRegisteredError"
                    class="text-xs text-red pt-1">Es existiert kein Konto zu dieser Email!</span>
                </div>
                <div class="flex flex-row">
                  <span [routerLink]="['/login']" class="text-sm text-green items-start hover:cursor-pointer"
                        mat-dialog-close>Zurück zum Login</span>
                </div>


              </div>
            </div>

            <div class="flex flex-col w-full">
              <bic-button class="h-[44px] mt-6"
                          [fullWidth]="true">
                {{ isNewVerification ? 'Email erneut senden' : 'Passwort zurücksetzen' }}
              </bic-button>
            </div>

          </form>
        </div>


        <div
          class="flex flex-col justify-between items-center z-40 w-[400px] h-full bg-white rounded-r-md relative gap-1"
          [class]="window.history.state['fromRegister'] ? 'animate-login' : '' ">
          <div class="flex w-full pt-24 flex-col justify-center items-center gap-1">
            <img class="w-[200px] h-[160px]" height="16" ngSrc="assets/logo_gradient.svg" width="16">
            <a class="text-[40px] font-bold font-brand text-blue -mt-6">planBIC</a>
          </div>


          <div class="flex flex-col justify-end items-center pb-16">
            <a class="text-sm text-blue">Noch nicht registriert?</a>
            <a [routerLink]="['/register']" [state]="{'fromLogin': true, 'fromRegister': false}"
               class="text-sm font-medium text-green" mat-dialog-close>Konto erstellen</a>
          </div>
        </div>

      </div>



    </ng-container>

  </div>

</div>
